import React, {
  useState, useCallback, useEffect, useMemo,
} from 'react';
import {
  EventListContainer,
} from '@fuww/library/src/Events';
import { useRouter } from 'next/router';
import dayjs from 'dayjs';
import SearchBox from './SearchBox';
import EventList from './EventList';
import debouncedReplaceRoute from '../../lib/debouncedReplaceRoute';
import { saveRouterState } from '../../lib/savedRouterState';
import getCurrentDate from '../../lib/getCurrentDate';

const Search = () => {
  const { query: { search: searchParameter, eventsPath } } = useRouter();
  const [search, setSearch] = useState(searchParameter || '');
  const { query } = useRouter();

  const minStartsAt = useMemo(
    () => dayjs(getCurrentDate()).startOf('day').toISOString(),
    [],
  );

  useEffect(() => debouncedReplaceRoute('events', {
    eventsPath,
    ...(search ? { search } : {}),
  }), [search, eventsPath]);

  useEffect(() => {
    saveRouterState('events', { query });
  }, [query]);

  const variables = useMemo(() => ({
    search: searchParameter || '',
    locales: [],
    first: 20,
    sort: search ? 'RELEVANCE' : 'STARTS_AT_ASCENDING',
    minStartsAt,
  }), [searchParameter, search, minStartsAt]);

  return (
    <>
      <SearchBox
        value={search}
        onChange={({ target: { value } }) => setSearch(value)}
        onClear={useCallback(() => setSearch(''), [setSearch])}
      />
      <EventListContainer>
        <EventList variables={variables} />
      </EventListContainer>
    </>
  );
};

export default Search;
